import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useThrottleFn } from 'ahooks';
import { useEffect } from 'react';

import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';

class pageSwiperStore {
  /**
   * swiperOptions 默认的属性值
   * @type {{simulateTouch: boolean, observeParents: boolean, releaseOnEdges: boolean, effect: string, mousewheel: boolean, fadeEffect: {}, slidesPerView: number, observe: boolean, direction: string}}
   */
  swiperOptions = {
    direction: 'vertical',
    slidesPerView: 1,
    observe: true,
    observeParents: true,
    mousewheel: false,
    releaseOnEdges: true,
    simulateTouch: false
  };

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: this.swiperOptions
  });

  constructor({ effectMode = pageSwiperEffect.FADE, ...rest } = {}) {
    Object.assign(this, rest);
    // //console.log(this.swiperOptions, this.baseSwiperStore, rest, effectMode);
    this.baseSwiperStore.swiperOptions = { ...this.baseSwiperStore.swiperOptions, ...effectMode };
  }

  /**
   * 全屏滚动鼠标监听
   * 因为使用swiper自带的鼠标上线滚动会出现页面闪动的问题
   * 因此通过监听鼠标滚动事件来实现全屏滚动
   * @param ev
   */
  handleScroll = ev => {
    return;
  };

  use() {
    const { run: onScroll } = useThrottleFn(this.handleScroll, { wait: 500, trailing: false });
    this.onScroll = onScroll;
    useEffect(
      () => {
        document.addEventListener('wheel', onScroll, false);
        return () => {
          document.removeEventListener('wheel', onScroll, false);
        };
      },
      [onScroll]
    );
  }
}

export default pageSwiperStore;
